import { render, staticRenderFns } from "./BatchBasicTable.vue?vue&type=template&id=a4c0ff2a&scoped=true&"
import script from "./BatchBasicTable.vue?vue&type=script&lang=js&"
export * from "./BatchBasicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c0ff2a",
  null
  
)

export default component.exports